export default __webpack_public_path__ + "static/media/108_desktop.61a9019c.jpg";